module.exports = __webpack_public_path__ + "static/media/EST.f6189d38.png";